/* eslint-disable react/prop-types */
import MUIDataTable from 'mui-datatables';

// @mui
import { Card, Container, Grid, TextField, InputAdornment, Box, Typography, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
import { useState, useEffect, useMemo } from 'react';
import Scrollbar from '../scrollbar/Scrollbar';
import MuiDatatablesTextLabels from '../../helper/labelTablas';

export default function TableListPagination({ 
  titulo, 
  columnas, 
  data, 
  loading, 
  onPageChange, 
  totalCount, 
  currentPage, 
  onSearch,
  disableSearch = false,
  customOptions = {} 
}) {
  const [searchText, setSearchText] = useState('');
  const [cedulaSearch, setCedulaSearch] = useState('');
  const [celularSearch, setCelularSearch] = useState('');
  const [emailSearch, setEmailSearch] = useState('');
  const [filteredData, setFilteredData] = useState(data);
  const [localSearch, setLocalSearch] = useState(false);

  // Actualizar datos filtrados cuando cambian los datos originales
  useEffect(() => {
    if (!localSearch) {
      setFilteredData(data);
    }
  }, [data, localSearch]);

  // Filtrar datos localmente
  const filterData = (searchTerm, searchField) => {
    setLocalSearch(true);
    
    if (!searchTerm.trim()) {
      setFilteredData(data);
      return;
    }
    
    const filteredResults = data.filter(item => {
      if (searchField === 'cedula') {
        return item.cedula && item.cedula.toString().includes(searchTerm);
      }
      if (searchField === 'celular') {
        return item.celular && item.celular.toString().includes(searchTerm);
      }
      if (searchField === 'email') {
        return item.email && item.email.toLowerCase().includes(searchTerm.toLowerCase());
      }
      // Búsqueda general (en todos los campos)
      return Object.values(item).some(val => 
        val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
    
    setFilteredData(filteredResults);
  };

  // Manejar búsqueda por cédula
  const handleCedulaSearch = (value) => {
    setCedulaSearch(value);
    // Limpiar los otros campos
    setCelularSearch('');
    setEmailSearch('');
    setSearchText('');
    
    filterData(value, 'cedula');
    
    // Si también queremos actualizar el backend
    if (onSearch && !value.trim()) {
      onSearch('');
    }
  };

  // Manejar búsqueda por celular
  const handleCelularSearch = (value) => {
    setCelularSearch(value);
    // Limpiar los otros campos
    setCedulaSearch('');
    setEmailSearch('');
    setSearchText('');
    
    filterData(value, 'celular');
    
    // Si también queremos actualizar el backend
    if (onSearch && !value.trim()) {
      onSearch('');
    }
  };

  // Manejar búsqueda por email
  const handleEmailSearch = (value) => {
    setEmailSearch(value);
    // Limpiar los otros campos
    setCedulaSearch('');
    setCelularSearch('');
    setSearchText('');
    
    filterData(value, 'email');
    
    // Si también queremos actualizar el backend
    if (onSearch && !value.trim()) {
      onSearch('');
    }
  };

  // Limpiar todos los campos de búsqueda y volver a los datos originales
  const clearAllSearches = () => {
    setSearchText('');
    setCedulaSearch('');
    setCelularSearch('');
    setEmailSearch('');
    setLocalSearch(false);
    setFilteredData(data);
    
    // Si también queremos actualizar el backend
    if (onSearch) {
      onSearch('');
    }
  };

  const options = {
    filterType: 'dropdown',
    textLabels: MuiDatatablesTextLabels,
    serverSide: true,
    count: totalCount,
    page: currentPage - 1,
    rowsPerPage: 20,
    rowsPerPageOptions: [20],
    searchText,
    onTableChange: (action, tableState) => {
      console.log('Acción:', action, 'Estado:', tableState);
      
      if (action === 'changePage') {
        onPageChange(tableState.page + 1);
      }
      if (action === 'search' && !disableSearch) {
        setSearchText(tableState.searchText);
        // Limpiar los otros campos de búsqueda
        setCedulaSearch('');
        setCelularSearch('');
        setEmailSearch('');
        
        if (tableState.searchText && tableState.searchText.trim()) {
          onSearch(tableState.searchText);
        } else if (onSearch) {
          onSearch('');
        }
      }
    },
    search: !disableSearch,
    searchPlaceholder: disableSearch ? 'Filtrado activo' : 'Buscar...',
    searchProps: {
      disabled: disableSearch
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: '40px' }}>
          <button
            onClick={() => applyNewFilters()}
            style={{
              background: '#1976d2',
              color: 'white',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Aplicar Filtros
          </button>
        </div>
      );
    },
    // Combinamos las opciones predeterminadas con las opciones personalizadas
    ...customOptions
  };
  
  return (
    <Container>
      {loading ? (
        <Grid>
          <Grid display="flex" justifyContent="center" alignItems="end">
            <Icon icon="line-md:loading-twotone-loop" color="#2a76d2" width="150" />
          </Grid>
        </Grid>
      ) : (
        <>
          {/* Campos de búsqueda avanzada */}
          {/* <Card sx={{ mb: 2, p: 2 }}>
            <Typography variant="subtitle1" gutterBottom>Búsqueda avanzada:</Typography>
            
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
              <TextField
                label="Buscar por cédula"
                variant="outlined"
                size="small"
                value={cedulaSearch}
                onChange={(e) => handleCedulaSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon icon="material-symbols:badge-outline" />
                    </InputAdornment>
                  ),
                }}
              />
              
              <TextField
                label="Buscar por celular"
                variant="outlined"
                size="small"
                value={celularSearch}
                onChange={(e) => handleCelularSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon icon="material-symbols:smartphone" />
                    </InputAdornment>
                  ),
                }}
              />
              
              <TextField
                label="Buscar por email"
                variant="outlined"
                size="small"
                value={emailSearch}
                onChange={(e) => handleEmailSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon icon="material-symbols:mail-outline" />
                    </InputAdornment>
                  ),
                }}
              />
              
              <IconButton 
                onClick={clearAllSearches}
                sx={{ ml: 1 }}
                color="primary"
              >
                <Icon icon="material-symbols:refresh" />
              </IconButton>
            </Box>
          </Card> */}
          
          {/* Tabla de datos */}
          <Card>
            <Scrollbar>
              <MUIDataTable 
                title={titulo} 
                data={data} 
                columns={columnas} 
                options={options} 
              />
            </Scrollbar>
          </Card>
        </>
      )}
    </Container>
  );
}